import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "История. 10 класс",
        subject: "Условно-графическая наглядность в обучении истории: понятие, способы работы, современные средства формирования умений (на примере темы «Советский союз в 20-30-е гг.»)",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Условно-графическая наглядность в обучении истории: понятие, способы работы, современные средства формирования умений (на примере темы «Советский союз в 20-30-е гг.»)",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Шапарина Ольга Николаевна",
                grade: "старший научный сотрудник, кандидат исторических наук, доцент",
                subGrade: "",
                imageSrc: "./images/author1.png"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: `<div style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'>
                                <p style="font-weight: bold; padding-bottom: 1rem;">Применение условно-графической наглядности позволяет учителю реализовать целый комплекс предметных умений при обучении истории в старшей школе как на базовом, так и на углубленном уровнях. Развитие цифровой среды даёт возможность педагогу применять онлайн-сервисы для быстрой и эффективной работы с таблицами, схемами, картами и т. п. на уроке и во внеурочной деятельности.  </p>
                                <p>Сложность темы связана с выходом новых источников и научных работ по периоду, что требует их систематизации, обновления уже существующих данных. Появление целого спектра онлайн-сервисов, позволяющих более продуктивно и быстро работать с созданием разного вида условно-графической наглядности, требует времени на овладение навыками работы с ними.  </p>
                                <br>
                                <p>Кейс поможет найти ответы на вопросы:</p>
                                <br>
                                <p>
                                <ol>
                                    <li>каковы возможности применения условно-графической наглядности по теме «Советский Союз в 1920-1930-е годы»;</li>
                                    <li>как работать с онлайн-сервисами, чтобы они сокращали время на подготовку к уроку и были помощниками на уроке.</li>
                                </ol>
                                </p>
                                </div>
                                `
                        }
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации",
            imagePath: "",
            id: "1",
            videoUrl: "./video/video.mp4",
            contentBefore: [{
                type: "text",
                text: ``
            }],
            contentAfter: [{
                type: "text",
                text: ``
            }]
        },
        {
            order: 3,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1012",
            title: "Практический модуль",
            htmlPath: "./interactive/dist/index.html",
            autoHeight: false
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Алексашкина Л. Н. Преподавание истории в школе: от педагогического проекта к практике. – Москва: ООО «Русское слово – учебник», 2018",
                "Методика обучения истории: учеб. для студ. учреждений высш. образования / [В.В. Барабанов, Н.Н. Лазукова, Э.В. Ванина и др.]; под ред. В.В. Барабанова, Н.Н. Лазуковой. – Москва: Издательский центр «Академия», 2016",
                "Абдулаев Э.Н., Морозов А.Ю. Историческое моделирование. Блоки обобщения по темам по истории Отечества // Преподавание истории в школе. – 2018. – №9",
                "Абдулаев Э.Н., Морозов, А.Ю. Виды обобщения в обучении истории. Практический аспект // Преподавание истории в школе. – 2017. – №10",
                "Абдулаев Э.Н. Организация учебной деятельности в процессе проведения обобщающего занятия – практический аспект // Преподавание истории в школе. – 2017. – №3",
                "Бекузарова Н.В., Шумовский О.И. Использование интерактивной карты для формирования исторических знаний // International Journal of Advanced Studies. – 2018. – Т. 8.  – № 4",
                "Белоусов К.Б. Использование опорных сигналов для формирования умений учебной работы (компетенций) на уроках истории // Актуальные направления развития научной и образовательной деятельности. Сборник научных трудов. Чебоксары, 2014",
                "Виноградова, М.В. Интерактивная доска при работе с картографическими ресурсами // Преподавание истории в школе. – 2016. – №2",
                "Власова Н.И., Дворжецкая О.Ю. Новый подход к изучению истории России через технологию «опорных схем» // Научно-методический электронный журнал Концепт. – 2014. – №T20",
                "Воронков В.К. Графические изображения как основа формирования фактологической базы при изучении истории // Современные образовательные ценности и обновление содержания образования. Сборник научных статей по материалам IV Международной научно-практической конференции: в 2- х частях. Под редакцией Т.В. Балабановой, Т.А. Гнилицкой, Е.В. Никулиной, В.И. Ерыгиной, Н.В. Немыкиной, К.В. Харченко. 2019",
                "Гражданинов И.Р. Технология обучения истории по опорным сигналам // Гражданинов И.Р. Учиться победно! Избранные методические труды по истории и педагогике. / Под общей редакцией Д.В. Кирюхина. Нижний Новгород, 2019",
                "Донская Д.Д. Кластер как один их методов повышения интереса к урокам истории // Перекрёстки истории. Актуальные проблемы исторической науки. Материалы XIV Всероссийской научной конференции. Ответственный редакторы Е.Г. Тимофеева, А.О. Тюрин, И.В. Торопицын. 2018",
                "Иванов О.В., Морозов, А.А. Проблемы формирования картографических умений у школьников на уроках истории // Преподавание истории в школе. – 2020. – №3",
                "Крутова Е.А., Ковригина С.В. Условно-графические наглядные пособия и их использование на уроках истории // Труды Братского государственного университета. Серия: Гуманитарные и социальные науки. 2016. Т. 1",
                "Методика обучения истории: трудные вопросы истории России: учебное пособие для бакалавриата и магистратуры / С.В. Любичанковский [и др.]; ответственный редактор С.В. Любичанковский. – Москва: Издательство Юрайт, 2019  –  (Образовательный процесс). – ISBN 978-5-534-11121-7. – Текст: электронный // Образовательная платформа Юрайт [сайт]. – URL: https://urait.ru/bcode/444507 (дата обращения: 11.03.2023)",
                "Морозов А.Ю. Картографический практикум по истории России XX- начало XXI в.: 9-11 классы/ А.Ю. Морозов, Э.Н. Абдулаев, О.В. Сдвижков. – Москва: ООО «Русское слово-учебник», 2016",
                "Морозов А.Ю., Абдулаев Э.Н., Сдвижков О.В. Картографический практикум по истории России XX- начала XXI в. Электронное учебное пособие для 9-11 классов. – Москва: ООО «Русское слово-учебник», 2023",
                "Нагимова А.О. Универсальная схема для изучения военных конфликтов на уроках истории // Преподавание истории в школе. – 2018. – №3",
                "Осипова М.И. Использование таблиц и схем на уроках истории и обществознания как средство систематизации и конкретизации знаний учащихся // Вестник научных конференций. – 2017. – №3-2(19)",
                "Петрухина Г.И. Использование схем и опорных конспектов на уроках истории // Социальный идентификатор: педагогические науки №1. Сборник по материалам «I Всероссийской научно-практической конференции по педагогическим наукам» – Социального идентификатора – socID.ru. 2016",
                "Синельников И.Ю. Как использовать картографические материалы при обучении истории // Преподавание истории и обществознания в школе. – 2022. – №5",
                "Студеникин М.Т. Методика преподавания истории в школе. – Москва: «Гуманитарный издательский центр ВЛАДОС», 2000",
                "Шапарина О.Н. Методика обучения истории: педагогический практикум. – Москва-Берлин: Direct-Media, 2021",
                "Щуринова И.А., Белянкова Е.И. Методические приемы работы со схемами, кластерами и интеллект-картами при изучении истории и обществознания // Современные образовательные технологии в мировом учебно-воспитательном пространстве. – 2016. – №7",
                "Щуринова И.А., Белянкова Е.И. Схемы на уроках истории: виды, функции и приёмы работы // Вестник ГОУ ДПО ТО «ИПК И ППРО ТО». Тульское образовательное пространство. – 2017. – №1"
            ],
            historical: [
                "Белковец Л.П., Белковец С.В. Советская дипломатия в борьбе за международное признание СССР. 1917–1935. – Москва: Проспект, 2023",
                "Вдовин А.И. СССР. История великой державы. 1922 – 1991. – Москва: РГ-Пресс, 2020",
                "Великие стройки СССР / автор-составитель Арсений Замостьянов. – Москва, 2022 ",
                "Давыдов А.Ю. «Социалистическая реконструкция» 1930-х годов: СССР идет к большой войне. – Санкт-Петербург: Евразия, 2023",
                "Историография истории России / А.А. Чернобаев и др. – Москва: Издательство Юрайт, 2014",
                "Лебина Н. Советская повседневность: нормы и аномалии. От военного коммунизма к большому стилю. – Москва: Новое литературное обозрение, 2023",
                "Попов, В.П. Очерки советской экономики: характер, механизмы, резервы, демографические последствия. – Москва: Новый Хронограф, 2020 ",
                "Трудные вопросы истории России. XX - начало XXI века Вып.1. / А.Б. Ананченко, В.П. Попов, В.Ж. Цветков, Д.О. Чураков. – Москва: МПГУ, 2016",
                "Хрестоматия по новейшей истории России. 1917-1945. – Москва: Дрофа, 2005"
            ],
            sites: [
                "",
            ],
            filesToDownload: [
                {
                    link: "./files/additional1.pdf",
                    fileName: "Информационный блок-кейс"
                }
            ]
        }
    ],
};
